import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { BookOpen, ArrowRight } from "lucide-react";
import { Button } from "../ui/button";
import { fetchBooks, money } from "../../lib/api";

export default function BooksTeaser() {
  const [books, setBooks] = useState([]);

  useEffect(() => {
    fetchBooks().then(setBooks).catch(() => {});
  }, []);

  if (books.length === 0) return null;

  return (
    <section id="books" className="py-16 sm:py-20 bg-cream/60" data-testid="books-teaser-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 grid lg:grid-cols-2 gap-10 items-center">
        <div>
          <div className="inline-flex items-center gap-2 bg-navy text-gold-light px-4 py-1.5 rounded-full text-sm font-medium mb-5">
            <BookOpen className="h-4 w-4" /> Word on Wealth (WOW) Series
          </div>
          <h2 className="font-serif text-navy text-3xl sm:text-4xl font-bold leading-tight">
            Books by Phil Dickens — <span className="text-gold-dark">Instant Digital Downloads</span>
          </h2>
          <p className="mt-4 text-gray-600 text-base md:text-lg leading-relaxed max-w-xl">
            Practical, faith-based guides to protect your home, master your credit, and build
            lasting wealth. Buy once, download instantly.
          </p>
          <Link to="/books">
            <Button className="mt-6 bg-navy hover:bg-navy-light text-white font-semibold h-12 px-7 text-base" data-testid="books-teaser-cta">
              Browse Books <ArrowRight className="h-5 w-5 ml-1.5" />
            </Button>
          </Link>
        </div>
        <div className="flex justify-center gap-6">
          {books.slice(0, 3).map((b, i) => (
            <Link to="/books" key={b.id} className="group text-center" data-testid={`books-teaser-cover-${i}`}>
              <img
                src={b.cover_url}
                alt={b.title}
                className={`h-56 sm:h-72 w-auto rounded-lg shadow-xl object-contain transition-transform group-hover:scale-105 ${i === 1 ? "sm:-translate-y-4" : ""}`}
              />
              <div className="mt-3 text-sm font-semibold text-navy">{money(b.price)}</div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
